import { format } from '@blockworks/platform/libs/date-fns';
import { AvatarGroup, FlexBox, Link, Text } from '@blockworks/ui/components';
import { DateFormat } from '@blockworks/ui/date-time';

interface SingleBylineProps {
    img?: string;
    name?: string;
    publishedAt?: {
        date: string;
        isEpoch: boolean;
    };
    href?: string;
    isExternalLink?: boolean;
}

const SingleByline = ({ img, name, publishedAt, href, isExternalLink }: SingleBylineProps) => {
    return (
        <FlexBox mb={3} alignItems="center" gap="md">
            <AvatarGroup stack="asc" size={32} avatars={[{ src: img, alt: name, href }]} hasTooltip></AvatarGroup>
            <FlexBox col>
                <Text>
                    <Link href={href} fontSize="xs" fontWeight="semibold" target={isExternalLink ? '_blank' : '_self'}>
                        {name}
                    </Link>
                </Text>
                {publishedAt && (
                    <Text size="xs">
                        <DateFormat
                            date={
                                publishedAt?.isEpoch ? format(Number(publishedAt.date) * 1000, 'PP') : publishedAt.date
                            }
                        />
                    </Text>
                )}
            </FlexBox>
        </FlexBox>
    );
};

export default SingleByline;
